{
  "eyebrow": "Potwierdź swój plan",
  "title": "Sprawdź i skonfiguruj.",
  "sub": "Cykl rozliczeniowy lub plan możesz zmienić w dowolnej chwili w panelu administratora.",
  "yourPlan": "Twój plan",
  "changePlan": "Zmień plan",
  "billing": "Cykl rozliczeniowy",
  "billingMonthLabel": "Płatność miesięczna",
  "billingMonthDesc": "Elastycznie. Anuluj w dowolnym momencie.",
  "billingYearLabel": "Płatność roczna",
  "billingYearDesc": "~17% zniżki. Płacisz raz w roku.",
  "addons": "Dodatki",
  "addon": {
    "ssec": "Ubezpieczenie społeczne (check-in/out@work)",
    "ssecDesc": "Tylko Belgia — automatyczna deklaracja Dimona.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Lokalizacja GPS w czasie rzeczywistym dla pojazdów firmowych. +4 €/pojazd/miesiąc.",
    "vehicles": "Pojazdy",
    "projectAddon": "Dodatek do zarządzania projektami",
    "projectAddonDesc": "Odblokowuje funkcje zarządzania projektami z Time Pro (prace dodatkowe, harmonogramowanie, zarządzanie podwykonawcami)."
  },
  "employees": {
    "title": "Ilu pracowników?",
    "active": "aktywnych użytkowników",
    "popular": "Większość zespołów wybiera {{n}}"
  },
  "estimate": "Szacowany koszt miesięczny",
  "estimateNote": "Bez VAT. Opłaty za użytkownika naliczane od aktywnych pracowników.",
  "estimateUnavailable": "Katalog cen niedostępny. Spróbuj ponownie, aby załadować aktualne ceny."
}
